
<app-group-box pageTitle="{{ title }}">
  <div class="row box-standard-padding">
    <div *ngFor="let item of items" class="col-12 col-sm-6 col-md-4 col-lg-3">
      <fa-icon class=" mr-10 c-pointer float-left" icon="info-circle" (click)="onInfoClick(item)"></fa-icon><label class="no-wrap-ellipsis" title="{{item?.name}}">{{item?.name}}</label>
    </div>
  </div>
</app-group-box>
